import { Typography, styled } from '@mui/material';
import { StatusThemeMappings } from 'dtos/jobs/ReportStatus';

interface BadgeProps {
  status: StatusThemeMappings;
}

const Badge = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'status',
})<BadgeProps>(({ theme, status }) => ({
  marginBottom: '4px',
  padding: '3px 10px',
  backgroundColor: theme.palette[status].main,
  borderRadius: '4px',
  color: theme.palette.getContrastText(theme.palette[status].main),
  boxDecorationBreak: 'clone',
}));

export { Badge };
